module.exports = __webpack_public_path__ + "media/images/empty-71a50dbba44c78128b221b7df7bb51f1.png";